function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import classNames from 'classnames';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { CSSTransition } from 'react-transition-group';
import ThemeExport from "../ThemeExport.js";
import { SpectrumThemeProvider } from "../theme/SpectrumThemeProvider.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Modal(_ref) {
  var className = _ref.className,
    children = _ref.children,
    _ref$role = _ref.role,
    role = _ref$role === void 0 ? 'role' : _ref$role,
    _ref$keyboard = _ref.keyboard,
    keyboard = _ref$keyboard === void 0 ? true : _ref$keyboard,
    _ref$clickOutside = _ref.clickOutside,
    clickOutside = _ref$clickOutside === void 0 ? true : _ref$clickOutside,
    _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
    _ref$centered = _ref.centered,
    centered = _ref$centered === void 0 ? false : _ref$centered,
    size = _ref.size,
    onOpened = _ref.onOpened,
    onClosed = _ref.onClosed,
    toggle = _ref.toggle,
    dataTestId = _ref['data-testid'];
  var element = useRef();
  var background = useRef(null);
  var backdropFade = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    backgroundClicked = _useState2[0],
    setBackgroundClicked = _useState2[1];
  var handleKeyDown = useCallback(event => {
    switch (event.key) {
      case 'Escape':
        toggle === null || toggle === void 0 || toggle();
        break;
      default:
        break;
    }
  }, [toggle]);
  useEffect(function addKeydownEventListener() {
    if (isOpen && keyboard) {
      window.addEventListener('keydown', handleKeyDown);
      return () => window.removeEventListener('keydown', handleKeyDown);
    }
  }, [handleKeyDown, isOpen, keyboard]);
  useEffect(function open() {
    if (isOpen && onOpened) {
      onOpened();
    }
  }, [onOpened, isOpen]);
  useEffect(function closed() {
    if (!isOpen && onClosed) {
      onClosed();
    }
  }, [onClosed, isOpen]);
  if (isOpen && !element.current) {
    element.current = document.createElement('div');
    element.current.setAttribute('style', 'padding-right: 15px; display: block');
    element.current.setAttribute('role', 'presentation');
    document.body.appendChild(element.current);
  }
  var onExited = () => {
    if (element.current) {
      document.body.removeChild(element.current);
      element.current = undefined;
    }
  };
  return element.current ? /*#__PURE__*/ReactDOM.createPortal(
  /*#__PURE__*/
  // Without the zIndex and position props
  // the modal is rendered on top of nested DatePicker popovers
  _jsxs(SpectrumThemeProvider, {
    isPortal: true,
    zIndex: 0,
    position: "relative",
    children: [/*#__PURE__*/_jsx(CSSTransition, {
      appear: true,
      mountOnEnter: true,
      unmountOnExit: true,
      in: isOpen,
      classNames: {
        appearActive: 'show',
        appearDone: 'show'
      },
      timeout: ThemeExport.transitionMs,
      onExited: onExited,
      nodeRef: backdropFade,
      children: /*#__PURE__*/_jsx("div", {
        ref: backdropFade,
        className: classNames('modal-backdrop fade'),
        style: {
          zIndex: 1050
        }
      })
    }), /*#__PURE__*/_jsx(CSSTransition, {
      appear: true,
      mountOnEnter: true,
      unmountOnExit: true,
      in: isOpen,
      classNames: {
        appearDone: 'show'
      },
      timeout: ThemeExport.transitionMs,
      onExited: onExited,
      nodeRef: background,
      children: /*#__PURE__*/_jsx("div", {
        ref: background,
        className: "modal fade",
        onMouseDown: e => {
          if (e.target === background.current) {
            setBackgroundClicked(true);
          } else {
            setBackgroundClicked(false);
          }
        },
        onMouseUp: e => {
          if (backgroundClicked && clickOutside && e.target === background.current && toggle !== undefined) {
            toggle();
          }
        },
        role: "dialog",
        style: {
          display: 'block'
        },
        children: /*#__PURE__*/_jsx("div", {
          className: classNames('modal-dialog', className, {
            'modal-lg': size === 'lg',
            'modal-sm': size === 'sm',
            'modal-xl': size === 'xl',
            'modal-dialog-centered': centered
          }),
          style: {
            zIndex: 1040
          },
          children: /*#__PURE__*/_jsx("div", {
            className: "modal-content",
            role: "presentation",
            "data-testid": dataTestId,
            children: children
          })
        })
      })
    })]
  }), element.current) : null;
}
export default Modal;
//# sourceMappingURL=Modal.js.map